module.exports = __webpack_public_path__ + "img/sv_full.0f8e6a85.png";